import { Link } from "react-router-dom";

export default function Privacy() {
  const updatedAt = "2024-12-25";

  return (
    <div
      className="min-h-screen bg-black text-white"
      style={{ fontFamily: '"Inter","Noto Sans JP",sans-serif' }}
    >
      {/* 上の固定ヘッダーに隠れないように余白 */}
      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        {/* パンくず/戻る */}
        <div className="flex items-center justify-between gap-4 mb-8">
          <div className="text-sm text-gray-400">
            <Link to="/" className="hover:text-cyan-300 transition-colors">
              ホーム
            </Link>
            <span className="mx-2 text-gray-600">/</span>
            <span className="text-gray-300">プライバシーポリシー</span>
          </div>

          <Link
            to="/"
            className="px-4 py-2 rounded-full border border-cyan-500/30 bg-black/40 backdrop-blur hover:border-cyan-500/60 hover:bg-white/5 transition-all text-sm"
          >
            ← 戻る
          </Link>
        </div>

        {/* 見出し */}
        <div className="relative mb-10">
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/15 via-purple-500/10 to-pink-500/15 blur-3xl rounded-3xl" />
          <div className="relative bg-black/40 backdrop-blur-xl border border-cyan-500/25 rounded-3xl p-8">
            <h1 className="text-3xl sm:text-4xl font-black mb-3">
              <span className="bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
                プライバシーポリシー
              </span>
            </h1>
            <p className="text-gray-300 leading-relaxed">
              株式会社GM（以下「当社」）は、当社が提供するサービスにおける個人情報の取扱いについて、
              以下のとおりプライバシーポリシーを定めます。
            </p>

            <div className="mt-4 text-sm text-gray-400">
              最終更新日：<span className="text-gray-200">{updatedAt}</span>
            </div>
          </div>
        </div>

        {/* 目次 */}
        <div className="bg-black/30 backdrop-blur border border-white/10 rounded-2xl p-6 mb-10">
          <div className="text-sm font-bold text-gray-200 mb-4">目次</div>
          <div className="grid sm:grid-cols-2 gap-2 text-sm">
            {[
              ["1", "取得する情報"],
              ["2", "利用目的"],
              ["3", "第三者提供"],
              ["4", "安全管理措置"],
              ["5", "開示等の請求"],
              ["6", "お問い合わせ窓口"],
              ["7", "改定"],
            ].map(([n, label]) => (
              <a
                key={n}
                href={`#sec-${n}`}
                className="text-gray-300 hover:text-cyan-300 transition-colors"
              >
                {n}. {label}
              </a>
            ))}
          </div>
        </div>

        {/* セクション共通の見た目 */}
        <Section id="sec-1" title="1. 取得する情報">
          <ul className="list-disc pl-5 space-y-2 text-gray-300">
            <li>氏名、会社名</li>
            <li>メールアドレス、電話番号</li>
            <li>お問い合わせ内容（自由記述）</li>
            <li>
              アクセス情報（IPアドレス、User Agent 等）
              <span className="text-gray-400"> ※不正アクセス対策・運用保守のため</span>
            </li>
          </ul>
        </Section>

        <Section id="sec-2" title="2. 利用目的">
          <ul className="list-disc pl-5 space-y-2 text-gray-300">
            <li>お問い合わせへの回答・連絡</li>
            <li>サービスの提供、改善、品質向上</li>
            <li>不正利用の防止、セキュリティ確保</li>
            <li>法令等への対応</li>
          </ul>
        </Section>

        <Section id="sec-3" title="3. 第三者提供">
          <p className="text-gray-300 leading-relaxed">
            当社は、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者に提供しません。
            ただし、業務委託先（メール送信、サーバー運用等）に必要な範囲で提供する場合があります。
          </p>
        </Section>

        <Section id="sec-4" title="4. 安全管理措置">
          <ul className="list-disc pl-5 space-y-2 text-gray-300">
            <li>アクセス制御、権限管理</li>
            <li>通信の保護（TLS/SSL 等）</li>
            <li>ログの監視・保管</li>
            <li>委託先の選定と監督</li>
          </ul>
        </Section>

        <Section id="sec-5" title="5. 開示等の請求">
          <p className="text-gray-300 leading-relaxed">
            ご本人から、保有個人データの開示、訂正、利用停止等の請求があった場合、
            法令に基づき合理的な範囲で対応します。
          </p>
        </Section>

        <Section id="sec-6" title="6. お問い合わせ窓口">
          <div className="bg-black/30 border border-white/10 rounded-2xl p-6">
            <div className="text-gray-300 leading-relaxed">
              株式会社GM
              <br />
              所在地：東京都北区王子本町二丁目14番14号
              <br />
              メール：<span className="text-gray-100 font-semibold">info.gm@gmsys-inc.com</span>
              <br />
              電話：<span className="text-gray-100 font-semibold">080-8928-9892</span>
            </div>
            <div className="text-xs text-gray-500 mt-3">
              ※お問い合わせ内容によっては回答にお時間をいただく場合があります。
            </div>
          </div>
        </Section>

        <Section id="sec-7" title="7. 改定">
          <p className="text-gray-300 leading-relaxed">
            当社は、本ポリシーを必要に応じて改定することがあります。改定後の内容は本ページに掲載します。
          </p>
        </Section>

        {/* 下部ナビ */}
        <div className="mt-12 flex items-center justify-between gap-4">
          <Link
            to="/"
            className="px-6 py-3 rounded-full bg-white/5 border border-cyan-500/25 hover:bg-white/10 hover:border-cyan-500/60 transition-all text-sm"
          >
            ホームへ戻る
          </Link>

          <a
            href="#top"
            className="px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-all text-sm text-gray-300"
          >
            ページ上部へ
          </a>
        </div>
      </div>
    </div>
  );
}

function Section({
  id,
  title,
  children,
}: {
  id: string;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section id={id} className="mb-10 scroll-mt-28">
      <div className="bg-black/40 backdrop-blur border border-white/10 rounded-3xl p-8">
        <h2 className="text-xl sm:text-2xl font-black mb-4">
          <span className="bg-gradient-to-r from-cyan-300 via-purple-300 to-pink-300 bg-clip-text text-transparent">
            {title}
          </span>
        </h2>
        {children}
      </div>
    </section>
  );
}
